import axiosInstance from './axiosInstance';

// Create/Update/UploadDrawings upload photos to Google Drive server-side (slow on the
// 1-vCPU box) — the default 30s axios timeout fires mid-upload with many photos and shows
// a false "Failed to submit" (backend keeps going → duplicates). Give them 5 minutes.
const LONG = { timeout: 300000 };
export const createDesignRequest = (dto) => axiosInstance.post('/DesignRequest/Create', dto, LONG);
export const listDesignRequests = () => axiosInstance.get('/DesignRequest/List');
export const getDesignRequest = (id) => axiosInstance.get(`/DesignRequest/Detail/${id}`);
export const updateDesignRequest = (id, dto) => axiosInstance.post(`/DesignRequest/Update/${id}`, dto, LONG);
export const markDesignDone = (id) => axiosInstance.post(`/DesignRequest/MarkDone/${id}`);
export const cancelDesignRequest = (id) => axiosInstance.post(`/DesignRequest/Cancel/${id}`);
// Designer uploads finished work (gallery). images: [{ dataBase64, fileName }], ≤5 MB each.
export const uploadDesignDrawings = (id, images) => axiosInstance.post(`/DesignRequest/UploadDrawings/${id}`, { images }, LONG);
